"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _product = require("@/api/product");
var _validate = require("@/utils/validate");
var _permission = require("@/utils/permission");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2025 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
var _default = exports.default = {
  name: 'creatCoupon',
  data: function data() {
    return {
      pickerOptions: {
        disabledDate: function disabledDate(time) {
          // return time.getTime() < new Date().setTime(new Date().getTime() - 3600 * 1000 * 24); //不限制未来时间
          return time.getTime() < Date.now() - 8.64e7 || time.getTime() > Date.now() + 600 * 8.64e7; //限制未来时间
        }
      },
      loading: false,
      threshold: false,
      termTime: [],
      props2: {
        children: 'child',
        label: 'name',
        value: 'id',
        checkStrictly: true,
        emitPath: false
      },
      couponType: 0,
      term: 'termday',
      ruleForm: {
        category: 1,
        isFixedTime: false,
        name: '',
        money: 1,
        minPrice: 1,
        day: null,
        isTimeReceive: false,
        productIds: '',
        receiveType: 1,
        isLimited: false,
        useStartTime: '',
        // 使用
        useEndTime: '',
        // 结束
        receiveStartTime: '',
        //领取
        receiveEndTime: '',
        sort: 0,
        total: 1,
        status: false,
        checked: [],
        identityType: 0,
        showInCenter: true
      },
      isForeverTime: [],
      rules: {
        name: [{
          required: true,
          message: '请输入优惠券名称',
          trigger: 'blur'
        }],
        day: [{
          required: true,
          message: '请输入使用有效期限（天）',
          trigger: 'blur'
        }],
        money: [{
          required: true,
          message: '请输入优惠券面值',
          trigger: 'blur'
        }],
        productIds: [{
          required: true,
          message: '请选择品类',
          trigger: 'change'
        }],
        checked: [{
          required: true,
          message: '请至少选择一个商品',
          trigger: 'change',
          type: 'array'
        }],
        isForeverTime: [{
          required: true,
          message: '请选择领取时间',
          trigger: 'change',
          type: 'array'
        }],
        total: [{
          required: true,
          message: '请输入发布数量',
          trigger: 'blur'
        }],
        minPrice: [{
          required: true,
          message: '请输入最低消费',
          trigger: 'blur'
        }]
      },
      tempRoute: {}
    };
  },
  created: function created() {
    this.tempRoute = Object.assign({}, this.$route);
  },
  mounted: function mounted() {
    if (this.$route.params.id) {
      this.setTagsViewTitle();
      this.getInfo();
    }
  },
  methods: {
    setTagsViewTitle: function setTagsViewTitle() {
      var title = this.$route.params.edit === 'edit' ? '优惠券编辑' : !this.$route.params.id ? '优惠券添加' : '优惠券复制';
      var route = Object.assign({}, this.tempRoute, {
        title: "".concat(title, "-").concat(this.$route.params.id)
      });
      this.$store.dispatch('tagsView/updateVisitedView', route);
    },
    handleTimestamp: function handleTimestamp() {},
    getInfo: function getInfo() {
      var _this2 = this;
      this.loading = true;
      (0, _product.couponInfoApi)(this.$route.params.id).then(function (res) {
        var info = res;
        _this2.ruleForm = {
          category: info.category,
          isFixedTime: info.isFixedTime,
          isTimeReceive: info.receiveEndTime ? true : false,
          //复制优惠券如果没有限制结束时间
          name: info.name,
          money: info.money,
          minPrice: info.minPrice,
          day: info.day,
          receiveType: info.receiveType,
          isLimited: info.isLimited,
          sort: info.sort,
          total: info.total,
          status: info.status,
          productIds: Number(info.productIds),
          checked: res.productList || [],
          identityType: typeof info.identityType === 'number' ? info.identityType : 0,
          showInCenter: typeof info.showInCenter === 'boolean' ? info.showInCenter : true
        };
        info.minPrice == 0 ? _this2.threshold = false : _this2.threshold = true;
        info.isTimeReceive ? _this2.isForeverTime = [info.receiveStartTime, info.receiveEndTime] : _this2.isForeverTime = [];
        info.isFixedTime && info.useStartTime && info.useEndTime ? _this2.termTime = [info.useStartTime, info.useEndTime] : _this2.termTime = [];
        _this2.loading = false;
      }).catch(function (res) {
        _this2.loading = false;
      });
    },
    handleRemove: function handleRemove(i) {
      this.ruleForm.checked.splice(i, 1);
    },
    changeGood: function changeGood() {
      var _this = this;
      this.$modalGoodList(function (row) {
        _this.ruleForm.checked = row;
      }, 'many', _this.ruleForm.checked);
    },
    save: function save(formName) {
      var _this3 = this;
      if (this.ruleForm.isFixedTime && !this.termTime || this.ruleForm.isFixedTime && !this.termTime.length) return this.$message.warning('请选择使用有效期限');
      if (this.ruleForm.isTimeReceive && !this.isForeverTime || this.ruleForm.isTimeReceive && !this.isForeverTime.length) return this.$message.warning('请选择请选择领取时间');
      if (!this.threshold) this.ruleForm.minPrice = 0;
      if (!this.ruleForm.isLimited) this.ruleForm.total = 0;
      this.ruleForm.isFixedTime && this.termTime.length ? (this.ruleForm.useStartTime = this.termTime[0], this.ruleForm.day = null) : this.ruleForm.useStartTime = '';
      this.ruleForm.isFixedTime && this.termTime.length ? (this.ruleForm.useEndTime = this.termTime[1], this.ruleForm.day = null) : this.ruleForm.useEndTime = '';
      this.ruleForm.isTimeReceive && this.isForeverTime.length ? this.ruleForm.receiveStartTime = this.isForeverTime[0] : this.ruleForm.receiveStartTime = '';
      this.ruleForm.isTimeReceive && this.isForeverTime.length ? this.ruleForm.receiveEndTime = this.isForeverTime[1] : this.ruleForm.receiveEndTime = '';
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this3.loading = true;
          (0, _product.couponSaveApi)(_this3.ruleForm).then(function () {
            _this3.$message.success('新增成功');
            _this3.loading = false;
            setTimeout(function () {
              _this3.$router.push({
                path: "/coupon/list"
              });
            }, 200);
            _this3.closeSelectedTag();
          }).catch(function () {
            _this3.loading = false;
          });
        } else {
          _this3.loading = false;
          return false;
        }
      });
    },
    submitForm: (0, _validate.Debounce)(function (formName) {
      var _this4 = this;
      if (this.ruleForm.category === 2) this.ruleForm.productIds = this.ruleForm.checked.map(function (item) {
        return item.id;
      }).join(',');
      if (this.ruleForm.category === 1) this.ruleForm.productIds = '';
      if (!this.$route.params.edit) {
        this.save(formName);
      } else {
        this.$refs[formName].validate(function (valid) {
          if (valid) {
            _this4.loading = true;
            (0, _product.couponProductEditApi)({
              id: _this4.$route.params.id,
              productIds: _this4.ruleForm.productIds
            }).then(function () {
              _this4.$message.success('编辑成功');
              _this4.loading = false;
              setTimeout(function () {
                _this4.$router.push({
                  path: "/coupon/list"
                });
              }, 200);
              _this4.closeSelectedTag();
            }).catch(function () {
              _this4.loading = false;
            });
          } else {
            _this4.loading = false;
            return false;
          }
        });
      }
    }),
    closeSelectedTag: function closeSelectedTag() {
      var that = this;
      that.$store.dispatch('tagsView/delView', that.$route).then(function (_ref) {
        var visitedViews = _ref.visitedViews;
        if (that.isActive(that.$route)) {
          that.toLastView(visitedViews, that.$route);
        }
      });
    }
  }
};